import axios from "axios";
import { message } from "antd";
import { getToken, removeToken } from "../utils/auth";
import { BASE_URL, TIMEOUT } from "./config";
const instance = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT,
  withCredentials: true, // 在这里设置
});
//添加拦截
instance.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
    // // 添加 withCredentials 配置
    // config.withCredentials = true;

    if (getToken() && !isToken) {
      config.headers["Authorization"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
  },
  (error) => {
    // 请求没有成功发出，可能是网络问题
    message.error("网络请求失败，请检查您的网络连接！", 1);
  }
);

instance.interceptors.response.use(
  (res) => {
    if (res.data.code == 401) {
      removeToken();
      localStorage.clear();
      window.location.reload();
      message.error("登录超时请重新登录！", 1, function () {});
    }
    return res.data;
  },
  (error) => {}
);

export default instance;
